export function ellipsifyHtml(html: string, maxLength: number = 100, ending: string = "..."): string {
    const virtualDivElement = document.createElement("div");
    virtualDivElement.innerHTML = html;

    let textLength = 0;

    function truncateNode(node: Node) {
        if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent || "";
            if (textLength + text.length > maxLength) {
                (node as Text).textContent = text.slice(0, maxLength - textLength) + ending;

                return true;
            }
            textLength += text.length;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            for (const child of Array.from(node.childNodes)) {
                if (truncateNode(child)) {
                    // Remove all siblings after the truncated node
                    while (child.nextSibling) {
                        child.nextSibling.remove();
                    }

                    return true;
                }
            }
        }

        return false;
    }

    truncateNode(virtualDivElement);

    return virtualDivElement.innerHTML;
}
